module.exports = __webpack_public_path__ + "static/chain_mail-345dd1ca46de67a8bf0840ddb40188c0.jpg";